import type React from 'react'

export function RelationshipChip({ children }: { children: React.ReactNode }) {
  return (
    <span
      // Phone: a very long relationship type is cut with an ellipsis instead of
      // pushing the group's count out of the accordion header.
      className="inline-flex max-md:block max-md:min-w-0 max-md:truncate"
      style={{
        alignItems: 'center',
        padding: '4px 10px',
        borderRadius: '9999px',
        background: 'var(--card)',
        color: 'var(--foreground)',
        border: '1px solid var(--border)',
        fontSize: 11,
        fontWeight: 600,
        fontFamily: 'var(--font-mono)',
        letterSpacing: 0.6,
        textTransform: 'uppercase',
      }}
    >
      {children}
    </span>
  )
}
